/* Associate the existing Dutch four-pack review widget with its ProductGroup.
 * The provider remains the only source of review data. Failure leaves its schema intact.
 */
(() => {
  if (location.hostname !== 'trixbasic.nl' || document.documentElement.lang !== 'nl') return;
  const families = { 'trix-basic-alpha': 'ALPHA', 'trix-basic-beta': 'BETA', 'trix-basic-gamma': 'GAMMA' };
  const handle = location.pathname.split('/').filter(Boolean).at(-1);
  const prefix = families[handle];
  if (!prefix) return;
  const skus = ['01', '03', '06', '12'].map(code => `${prefix}-${code}`);
  const sameSkus = values => values.length === 4 && new Set(values).size === 4 && skus.every(sku => values.includes(sku));
  const parse = node => { try { return JSON.parse(node.textContent); } catch { return null; } };
  const validRating = rating => {
    if (!rating || !['AggregateRating', 'Rating'].includes(rating['@type'])) return false;
    const min = Number(rating.worstRating ?? 1), max = Number(rating.bestRating ?? 5);
    const value = Number(rating.ratingValue);
    return min === 1 && max === 5 && Number.isFinite(value) && value >= min && value <= max;
  };
  const validReviews = reviews => Array.isArray(reviews) && reviews.length > 0 && reviews.every(review =>
    review?.['@type'] === 'Review' && review.author?.name && validRating(review.reviewRating));
  function reconcile() {
    const widget = document.querySelector('etrusted-widget[data-etrusted-widget-id="wdg-bec011f8-b20a-41e5-890d-7b5391f59aa0"]');
    if (!widget || !sameSkus((widget.getAttribute('data-sku') || '').split(',').map(sku => sku.trim()))) return;
    const target = document.querySelector('script[data-trix-product-schema]');
    const group = target && parse(target);
    if (group?.['@type'] !== 'ProductGroup' || group['@id'] !== `/products/${handle}#product` ||
        !group.productGroupID || typeof group.name !== 'string' || !group.name || !Array.isArray(group.hasVariant) ||
        !sameSkus(group.hasVariant.map(variant => variant?.sku)) ||
        !group.hasVariant.every(variant => variant['@type'] === 'Product' && variant.gtin &&
          variant.offers?.['@type'] === 'Offer' && variant.offers.priceCurrency && variant.offers.url)) return;
    // Only direct head/body scripts match the provider's standalone payload.
    for (const source of document.querySelectorAll('head > script[type="application/ld+json"], body > script[type="application/ld+json"]')) {
      const data = parse(source);
      if (data?.['@type'] !== 'Product' || !skus.includes(data.sku) || data['@id'] !== data.sku) continue;
      const variant = group.hasVariant.find(item => item.sku === data.sku);
      if (typeof data.name !== 'string' || !data.name.startsWith(`${group.name} - `) || !data.gtin || String(data.gtin) !== String(variant.gtin) ||
          !/^https:\/\/productimages\.etrusted\.com\//.test(data.image || '')) continue;
      const count = Number(data.aggregateRating?.reviewCount);
      if (!validRating(data.aggregateRating) || !Number.isSafeInteger(count) || count <= 0 || !validReviews(data.review) || data.review.length > count) continue;
      const next = { ...group, aggregateRating: data.aggregateRating, review: data.review };
      const serialized = JSON.stringify(next);
      if (target.textContent !== serialized) target.textContent = serialized;
      // Confirm the write before removing the matched redundant script.
      if (target.textContent === serialized) {
        source.remove();
        Object.assign(group, next);
      }
    }
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; reconcile(); });
  };
  const relevant = node => node.nodeType === 1 && (node.matches?.('script, etrusted-widget') || node.querySelector?.('script, etrusted-widget'));
  new MutationObserver(records => {
    if (records.some(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (element?.matches?.('[data-trix-product-schema]')) return false;
      return element?.matches?.('script[type="application/ld+json"], etrusted-widget') || [...record.addedNodes].some(relevant);
    })) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-sku'] });
  schedule();
})();
